export default class RiskFormUtils {
  // Extraire l'ID du client depuis l'URL
  static getClientId() {
    const pathParts = window.location.pathname.split('/')
    return pathParts[2] // /clients/:id/...
  }

  // Extraire l'ID du dossier depuis l'URL
  static getCfileId() {
    const pathParts = window.location.pathname.split('/')
    const cfileId = pathParts[2] // /cfiles/:id/...
    
    // Si l'ID contient un tiret (ex: 62-greg), extraire la partie numérique
    if (cfileId && cfileId.includes('-')) {
      return cfileId.split('-')[0]
    }
    
    return cfileId
  }

  // Obtenir la valeur du select de niveau de risque
  static getSelectedRiskLevel() {
    const select = document.getElementById('risk_level_select')
    if (!select) return null
    
    const value = select.value
    // Retourner null si la valeur est vide ou "Sélectionner un niveau de risque"
    return (value && value !== "") ? value : null
  }

  // Vérifier si une option existe dans un select
  static optionExists(select, value) {
    return Array.from(select.options).some(option => option.value === value.toString())
  }

  // Définir la valeur d'un select et déclencher l'événement change
  static setSelectValue(select, value, triggerChange = true) {
    if (select && this.optionExists(select, value)) {
      select.value = value
      if (triggerChange) {
        select.dispatchEvent(new Event('change'))
      }
      return true
    }
    return false
  }

  // Créer un FormData à partir d'un formulaire
  static createFormData(form) {
    const formData = new FormData()
    
    // Collecter manuellement tous les champs du formulaire
    const inputs = form.querySelectorAll('input, textarea, select')
    console.log(`🔍 Formulaire trouvé avec ${inputs.length} champs`)
    
    let validFields = 0
    let ignoredFields = 0
    
    inputs.forEach(input => {
      if (input.name && input.name.startsWith('answers[')) {
        // Pour les champs de type checkbox, gérer la valeur booléenne
        if (input.type === 'checkbox') {
          const value = input.checked ? 'true' : 'false'
          formData.append(input.name, value)
          console.log(`✅ Champ ajouté: ${input.name} = ${value}`)
          validFields++
        } else {
          formData.append(input.name, input.value)
          console.log(`✅ Champ ajouté: ${input.name} = ${input.value}`)
          validFields++
        }
      } else {
        console.log(`⚠️ Champ ignoré: ${input.name} (type: ${input.type})`)
        ignoredFields++
      }
    })
    
    console.log(`📊 Résumé: ${validFields} champs valides, ${ignoredFields} champs ignorés`)
    
    // Ajouter le niveau de risque actuel aux données
    const currentRiskLevelId = this.getSelectedRiskLevel()
    if (currentRiskLevelId) {
      formData.append('risk_level_id', currentRiskLevelId)
      console.log(`✅ Risk level ajouté: ${currentRiskLevelId}`)
    }
    
    // Debug: vérifier que tous les champs sont bien collectés
    console.log('🔍 FormData final créé avec les champs suivants:')
    for (let [key, value] of formData.entries()) {
      console.log(`  ${key}: ${value}`)
    }
    
    return formData
  }

  // Collecter les données du formulaire
  static collectFormData(form) {
    const formData = {}
    const inputs = form.querySelectorAll('input, textarea, select')
    
    inputs.forEach(input => {
      if (input.name && input.name.startsWith('question_')) {
        const questionId = input.name.replace('question_', '')
        if (input.type === 'checkbox') {
          formData[questionId] = input.checked ? '1' : '0'
        } else {
          formData[questionId] = input.value
        }
      }
    })
    
    return formData
  }

  // Afficher une notification
  static showNotification(message, type = 'info') {
    // Pour l'instant, utiliser alert - à remplacer par une notification plus élégante
    alert(message)
  }

  // Afficher une erreur
  static showError(message) {
    this.showNotification(message, 'error')
  }

  // Afficher un succès
  static showSuccess(message) {
    this.showNotification(message, 'success')
  }

  // Gérer les erreurs de manière uniforme
  static handleError(error, context = '') {
    console.error(`Erreur ${context}:`, error)
    this.showError(`Erreur ${context}: ${error.message}`)
  }

  // Traductions
  static getTranslation(key) {
    const translations = {
      'risk_form.no_questions_found': 'Aucune question trouvée pour ce niveau de risque.',
      'risk_form.save_answers': 'Enregistrer les réponses',
      'risk_form.access_button': 'Accéder',
      'risk_form.edit_answers': 'Modifier les réponses',
      'risk_form.existing_answers_title': 'Réponses enregistrées',
      'risk_form.answers_saved': 'Réponses enregistrées avec succès',
      'risk_form.error_loading': 'Erreur lors du chargement des questions',
      'risk_form.error_saving': 'Erreur lors de l\'enregistrement des réponses',
      'risk_form.loading': 'Chargement...'
    }
    return translations[key] || key
  }
} 